import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  pt: {
    inicioNav: "Início",
    sobreNav: "Sobre",
    palesoNav: "Palestrantes",
    patroNav: "Patrocinadores",
    orgNav: "Organização",
    semanaTec: "VI Semana de Tecnologia da Informação",
    local: "Universidade Federal de Lavras",
    data: "9 a 13 de novembro de 2020",
    entrarButton: "ENTRAR",
    cadastreButton: "INSCREVA-SE",
    tituloSobre: "A SETI",
    textoSobre:
      "Fala galera! Esperamos que estejam bem. Na medida do possível, ficaremos mais próximos: lembrem-se que cada dia que passa é um dia a menos de distanciamento. Mas nesse meio tempo, faremos acontecer um dos melhores e maiores eventos de tecnologia da informação da região e, dessa vez, 100% online. Isso mesmo! Com o intuito de contribuir para com o seu crescimento profissional, comunicamos que iremos oferecer conteúdos de ótima qualidade. Preparem-se! Esperamos vocês para participarmos juntos dessa incrível experiência. #EMCASACOMASE7I",
    tituloPalestrante: "PALESTRANTES",
    tituloPatrocinadores: "PATROCINADORES",
    cotaDiamante: "DIAMANTE",
    cotaOuro: "OURO",
    cotaPrata: "PRATA",
    tituloOrganizacao: "ORGANIZAÇÃO",
    tituloApoio: "APOIO",
    tituloLocalizacao: "LOCALIZAÇÃO",
    textoLocalizacao: "Totalmente online e direto da sua casa!",
    queroPalestrar: "QUERO PALESTRAR",
    feedbackButton: "FEEDBACK"
  },
  en: {
    inicioNav: "Home",
    sobreNav: "About",
    palesoNav: "Speakers",
    patroNav: "Sponsors",
    orgNav: "Organization",
    semanaTec: "VI Information Technology Week",
    local: "Federal University of Lavras",
    data: "November 9th to 13th 2020",
    entrarButton: "SIGN IN",
    cadastreButton: "SUBSCRIBE",
    tituloSobre: "THE SETI",
    textoSobre:
      "Hello, guys! We hope you’re all well. When it’s possible, we are going to be together again: each day that passes, less a day we are apart. But, in between that, we’re gonna make one of the best and biggest technology event of region, this time, 100% online. That’s right! Thinking about your personal growth, we are here to announce a lot of great content! Get ready! We’ll be waiting for you all to join this amazing journey. #ATHOMEWITHSE7I",
    tituloPalestrante: "SPEAKERS",
    tituloPatrocinadores: "SPONSORS",
    cotaDiamante: "DIAMOND",
    cotaOuro: "GOLD",
    cotaPrata: "SILVER",
    tituloOrganizacao: "ORGANIZATION",
    tituloApoio: "SUPPORT",
    tituloLocalizacao: "LOCATION",
    textoLocalizacao: "Totally online and straight from your home!",
    queroPalestrar: "BE A SPEAKER",
    feedbackButton: "FEEDBACK"
  },
};

const i18n = new VueI18n({
  locale: "pt", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
